import validatePolish from "./personal/polish"
import validateSpanish from "./personal/spanish"

const personal = () => {
  return { validatePolish, validateSpanish }
}

export default personal
